"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonConstraintsBuilder = void 0;

var boolean_1 = require("../../boolean");

var constant_1 = require("../../constant");

var double_1 = require("../../double");

function jsonConstraintsBuilder(stringArbitrary, constraints) {
  var _constraints$depthFac = constraints.depthFactor,
      depthFactor = _constraints$depthFac === void 0 ? 0.1 : _constraints$depthFac,
      maxDepth = constraints.maxDepth;
  var key = stringArbitrary;
  var values = [(0, boolean_1.boolean)(), (0, double_1.double)({
    next: true,
    noDefaultInfinity: true,
    noNaN: true
  }), stringArbitrary, (0, constant_1.constant)(null)];
  return {
    key: key,
    values: values,
    depthFactor: depthFactor,
    maxDepth: maxDepth
  };
}

exports.jsonConstraintsBuilder = jsonConstraintsBuilder;